/** @format */

import { reducerDebug } from '../../core/debug';

export const serviceCodeConstants = {
    SERVICE_CODE_LIST: 'service_code_list',
    SERVICE_CODE_ADD: 'service_code_add',
    SERVICE_CODE_EDIT: 'service_code_edit',
    SERVICE_CODE_REMOVE: 'service_code_remove',
    SERVICE_CODE_HISTORY_LIST: 'service_code_history_list',
};

export const fractionServiceCodeConstants = {
    FRACTION_SERVICE_CODE_LIST: 'fraction_service_code_list',
    FRACTION_SERVICE_CODE_ADD: 'fraction_service_code_add',
    FRACTION_SERVICE_CODE_EDIT: 'fraction_service_code_edit',
    FRACTION_SERVICE_CODE_REMOVE: 'fraction_service_code_remove',
};

export type serviceCodeReducerType = {
    type: string;
    collections?: any;
    success: boolean;
    data: any;
};

export function serviceCodeReducers(state = {}, action: serviceCodeReducerType): object {
    reducerDebug('Service Code reducer: ' + action.type);
    switch (action.type) {
        case serviceCodeConstants.SERVICE_CODE_HISTORY_LIST:
        case serviceCodeConstants.SERVICE_CODE_LIST:
            return {
                ...state,
                type: action.type,
                collections: action.collections,
            };
        case serviceCodeConstants.SERVICE_CODE_EDIT:
        case serviceCodeConstants.SERVICE_CODE_REMOVE:
        case serviceCodeConstants.SERVICE_CODE_ADD:
            return {
                ...state,
                type: action.type,
                success: true,
                data: action.data,
            };
        default:
            return {
                ...state,
                success: false,
            };
    }
}

export function fractionServiceCodeReducers(state = {}, action: serviceCodeReducerType): object {
    reducerDebug('Fraction Service Code reducer: ' + action.type);
    switch (action.type) {
        case fractionServiceCodeConstants.FRACTION_SERVICE_CODE_LIST:
            return {
                ...state,
                type: action.type,
                collections: action.collections,
            };
        case fractionServiceCodeConstants.FRACTION_SERVICE_CODE_EDIT:
        case fractionServiceCodeConstants.FRACTION_SERVICE_CODE_REMOVE:
        case fractionServiceCodeConstants.FRACTION_SERVICE_CODE_ADD:
            return {
                ...state,
                type: action.type,
                success: true,
                data: action.data,
            };
        default:
            return {
                ...state,
                success: false,
                deletedSuccess: false,
            };
    }
}
